import type { RecordOf } from 'immutable';
import { Map as ImmutableMap, Record as ImmutableRecord } from 'immutable';

import type { CreditProfilePii } from './creditProfileSchema';

export type { CreditProfilePii } from './creditProfileSchema';

export type CreditProfileType = {
  id?: string;
  creditProfileRegistrationId?: string;
  providerCreditProfileRegistrationId?: string;
  creditProviderId?: string;
  status?: string;
  creditProfileId?: number;
  creditReportId?: number;
  creditProfileRegistrationModifiedAt?: string;
  creditProfileRegistrationCreatedAt?: string;
  creditProfile?: CreditProfilePii;
  datasetId?: string;
  numberOfQuestions?: number;
};

export type CreditProfile = RecordOf<CreditProfileType>;

export const mkCreditProfile = ImmutableRecord<CreditProfileType>({
  id: undefined,
  creditProfileRegistrationId: undefined,
  providerCreditProfileRegistrationId: undefined,
  creditProviderId: undefined,
  status: undefined,
  creditProfileId: undefined,
  creditReportId: undefined,
  creditProfileRegistrationModifiedAt: undefined,
  creditProfileRegistrationCreatedAt: undefined,
  creditProfile: undefined,
  datasetId: undefined,
  numberOfQuestions: 0,
});

export type CreditProfileStoreProps = {
  attempts?: number;
  resourcesById: ImmutableMap<string, CreditProfile>;
  resourceName?: string;
  lastSyncDate?: string;
  loadPending: boolean;
  isLoading: boolean;
  isPolling: boolean;
  isRetryLoading: boolean;
  isContinuing: boolean;
  retryError?: object;
  lastRetryDate?: string | null;
  error?: object | null;
};

export type CreditProfileStore = RecordOf<CreditProfileStoreProps>;

export const mkCreditProfileStoreType = ImmutableRecord<CreditProfileStoreProps>({
  attempts: 0,
  resourcesById: ImmutableMap(),
  resourceName: undefined,
  lastSyncDate: undefined,
  loadPending: true,
  isLoading: false,
  isPolling: false,
  isRetryLoading: false,
  isContinuing: false,
  retryError: undefined,
  lastRetryDate: undefined,
  error: undefined,
});

// No SSN: core resolves it from the view-owned registration flow at the request boundary.
export type RegisterCreditProfilePayload = {
  creditProfileRegistrationId?: string;
  id?: string;
};

export const CREDIT_PROFILE_REDUCER_KEY = 'creditProfileStore';

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [CREDIT_PROFILE_REDUCER_KEY]: CreditProfileStore;
  }
}
